import type { UseFetchOptions } from '#app'

/**
 * Wrapper de useFetch para Better Auth en SSR
 *
 * Llama al backend absoluto (NUXT_PUBLIC_API_BASE_URL) y, en SSR,
 * reenvía el header Cookie de la petición entrante.
 *
 * Requiere cookies cross-subdomain en el backend (Domain=.ejemplo.com)
 * para que la cookie de sesión llegue al host del frontend en hard refresh.
 */
export function useAuthFetch<T>(url: string | Request, options?: UseFetchOptions<T>) {
  const config = useRuntimeConfig()
  const apiBaseUrl = String(config.public.apiBaseUrl || 'http://localhost:3001').replace(/\/$/, '')

  const urlString = typeof url === 'string' ? url : url.url
  const path = urlString.replace(/^https?:\/\/[^/]+/, '')
  const absoluteUrl = `${apiBaseUrl}${path.startsWith('/') ? path : `/${path}`}`

  const headers = import.meta.server
    ? useRequestHeaders(['cookie'])
    : undefined

  return useFetch(absoluteUrl, {
    ...options,
    credentials: 'include',
    headers: {
      ...(options?.headers as Record<string, string> | undefined),
      ...headers
    }
  })
}
